export enum Devicetype {
  MobilePortrait = 0,
  MobileLandscape = 1,
  TabletPortrait = 2,
  TabletLandscape = 3,
  Desktop = 4
}
